import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import {
  completePurchaseOrder,
  createReceive,
  resetCreateReceive,
  editReceive,
  fetchReceiveDetail,
  convertPOToReceive,
  setPostingDate,
} from '../../actions/receive_actions';
import { fetchInventories } from '../../actions/inventories_actions';
import { fetchPurchaseOrderDetail, setDefaultOfForm } from '../../actions/purchaseOrders_actions';
import { printWarehouseReceive } from '../../actions/print_actions';

import ReceiveForm from '../../components/Inventories/receiveForm';

const validate = (values) => {
  const errors = {};
  if (!values.Name) {
    errors.Name = 'Required';
  }
  return errors;
};

const receiveForm = reduxForm({
  form: 'receiveForm',
  validate,
})(ReceiveForm);

const selector = formValueSelector('receiveForm');

function mapStateToProps(state) {
  const toZoneValue = selector(state, 'ToZone');
  const toBinValue = selector(state, 'ToBin');
  const rcvQuantityValue = selector(state, 'RcvQuantity');
  const rcvUnitPriceValue = selector(state, 'RcvUnitPrice');
  const rcvTotalPriceValue = selector(state, 'RcvTotalPrice');
  const palletValue = selector(state, 'Pallet');
  const storageRateValue = selector(state, 'StorageRate');
  const rtnQuantityValue = selector(state, 'RtnQuantity');
  const postingDate = selector(state, 'PostingDate');
  const note = selector(state, 'Note');
  const HandlingCost = selector(state, 'HandlingCost');
  const MiscCost = selector(state, 'MiscCost');
  const ShippingCost = selector(state, 'ShippingCost');
  const priceAdjustment = selector(state, 'PriceAdjustment');
  const ShareCost = selector(state, 'ShareCost');
  const InvoiceFinalPrice = selector(state, 'InvoiceFinalPrice') || 0;
  const TaxRate = selector(state, 'TaxRate') || 0;
  const TotalCRV = selector(state, 'TotalCRV');
  const InvoiceNum = selector(state, 'InvoiceNum');
  const PackingNum = selector(state, 'PackingNum');
  const PostingDate = selector(state, 'PostingDate');
  const InvoiceDate = selector(state, 'InvoiceDate');
  const ReceivingPrice = selector(state, 'ReceivingPrice');
  const Warehouse = selector(state, 'Warehouse');
  const container_num = selector(state, 'container_num');

  return {
    note,
    rcvQuantityValue,
    rcvUnitPriceValue,
    rcvTotalPriceValue,
    palletValue,
    storageRateValue,
    rtnQuantityValue,
    toZoneValue,
    toBinValue,
    postingDate,
    HandlingCost,
    MiscCost,
    ShippingCost,
    priceAdjustment,
    ShareCost,
    InvoiceFinalPrice,
    TaxRate,
    TotalCRV,
    InvoiceNum,
    PackingNum,
    PostingDate,
    InvoiceDate,
    ReceivingPrice,
    Warehouse,
    container_num,

    currentReceive: state.receives.currentReceive,
    currentReceiveDetail: state.receives.currentReceiveDetail,
    detailIsLoading: state.receives.detailIsLoading,
    detailError: state.receives.detailError,
    isCreating: state.receives.isCreating,
    createError: state.receives.createError,
    created: state.receives.created,
    createdReceive: state.receives.createdReceive,
    isEditing: state.receives.isEditing,
    editError: state.receives.editError,
    edited: state.receives.edited,
    isCompleting: state.receives.isCompleting,
    completeError: state.receives.completeError,
    completed: state.receives.completed,
    initialValues: state.receives.currentReceiveDetail,
    receiveLoading: state.receives.receiveLoading,

    currentPurchaseOrder: state.purchaseOrders.currentPurchaseOrder,
    currentPurchaseOrderDetail: state.purchaseOrders.currentPurchaseOrderDetail,

    inventories: state.inventories.all,
    inventoriesIsLoading: state.inventories.isLoading,
    inventoriesError: state.inventories.error,

    requestingWarehouseReceivePdf: state.print.requestingWarehouseReceivePdf,
    warehouseReceivePdf: state.print.warehouseReceivePdf,
  };
}

export default connect(mapStateToProps, {
  completePurchaseOrder,
  createReceive,
  resetCreateReceive,
  editReceive,
  fetchReceiveDetail,
  fetchInventories,
  fetchPurchaseOrderDetail,
  convertPOToReceive,
  setPostingDate,
  setDefaultOfForm,
  printWarehouseReceive,
})(receiveForm);



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/receiveForm.jsx